import type { ComponentContentSchema } from '@vibesites/runtime';
import { useContentToken, EditableToken } from '@vibesites/runtime/react';

/**
 * Short notice placed above floor-plan inventory (Apartment Sync) to disclose
 * third-party fraud verification during the application process.
 */
export function FraudVerificationNotice() {
  const message = useContentToken('fraudverificationnotice.message');

  return (
    <section className="fraud-verification-notice" aria-label="Fraud verification notice">
      <EditableToken
        path="fraudverificationnotice.message"
        as="p"
        className="fraud-verification-notice__message"
      >
        {message}
      </EditableToken>

      <style>{`
        .fraud-verification-notice {
          width: 100%;
          max-width: 72rem;
          margin: 0 auto;
          padding: 1.25rem 1rem 0.25rem;
          background: var(--vibe-color-background);
        }

        .fraud-verification-notice__message {
          margin: 0;
          font-family: var(--vibe-font-body);
          font-size: 0.9375rem;
          line-height: 1.55;
          color: var(--vibe-color-text-muted, var(--vibe-color-text));
          text-align: center;
        }

        @media (min-width: 768px) {
          .fraud-verification-notice {
            padding: 1.5rem 1.5rem 0.5rem;
          }

          .fraud-verification-notice__message {
            font-size: 1rem;
          }
        }
      `}</style>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FraudVerificationNotice',
  displayName: 'Fraud Verification Notice',
  tokens: {
    'fraudverificationnotice.message': {
      label: 'Notice Text',
      type: 'text',
      defaultValue:
        'This community partners with a 3rd party verification platform to detect fraud through the application process.',
    },
  },
};

(FraudVerificationNotice as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default FraudVerificationNotice;
